import React from "react";

export default function HeaderPrescription({
  clinicDetails,
  doctorData,
  hospitalAccountData,
}) {
  return (
    <>
      {clinicDetails?.prescription_HeaderYN === "Y" ||
      (clinicDetails?.prescription_HeaderYN === "C" &&
        !doctorData?.headerDetails) ? (
        <div
          style={{
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            flexWrap: "nowrap",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 12,
            paddingBottom: 8,
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 12,
              minWidth: 0,
              flex: "1 1 auto",
            }}
          >
            {hospitalAccountData?.logoB64 ? (
              <img
                src={"data:image/jpeg;base64," + hospitalAccountData.logoB64}
                alt="Clinic Logo"
                style={{
                  width: 72,
                  height: 72,
                  objectFit: "contain",
                  flex: "0 0 auto",
                }}
              />
            ) : null}
            <div style={{ flex: "1 1 auto", minWidth: 0 }}>
              <div
                style={{
                  fontSize: 18,
                  fontFamily: "serif",
                  fontWeight: 600,
                  color: "#154A6B",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {clinicDetails?.clinic_Name}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 8,
                  marginTop: 6,
                  flexWrap: "wrap",
                  fontSize: 12,
                }}
              >
                {(clinicDetails?.morningFromTime ||
                  clinicDetails?.morningToTime) && (
                  <div style={{ color: "#A7527E", fontWeight: 500 }}>
                    <span style={{ fontWeight: 600 }}>Morning:</span>
                    <span style={{ color: "#184B67", marginLeft: 6 }}>
                      {clinicDetails?.morningFromTime &&
                      clinicDetails?.morningToTime
                        ? `${clinicDetails.morningFromTime} - ${clinicDetails.morningToTime}`
                        : ""}
                    </span>
                  </div>
                )}
                {(clinicDetails?.eveningFromTime ||
                  clinicDetails?.eveningToTime) && (
                  <div style={{ color: "#A7527E", fontWeight: 500 }}>
                    <span style={{ fontWeight: 600 }}>Evening:</span>
                    <span style={{ color: "#184B67", marginLeft: 6 }}>
                      {clinicDetails?.eveningFromTime &&
                      clinicDetails?.eveningToTime
                        ? `${clinicDetails?.eveningFromTime} - ${clinicDetails?.eveningToTime}`
                        : ""}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div
            style={{
              textAlign: "right",
              color: "#184B67",
              flex: "0 0 220px",
              minWidth: 160,
            }}
          >
            <div
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: "#244D67",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {doctorData?.userSalutation} {doctorData?.userFirstName}{" "}
              {doctorData?.userLastName}
            </div>
            <div style={{ fontSize: 12, color: "#244D67", marginTop: 6 }}>
              <div style={{ fontSize: 12 }}>{doctorData?.qualification}</div>
              <div style={{ fontSize: 12, fontWeight: 600 }}>
                {doctorData?.speciality}
              </div>
              {doctorData?.registrationNumber ? (
                <div style={{ fontSize: 12 }}>
                  Reg.no. {doctorData?.registrationNumber}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ) : clinicDetails?.prescription_HeaderYN === "C" &&
        doctorData?.headerDetails ? (
        <div
          dangerouslySetInnerHTML={{
            __html: atob(doctorData.headerDetails).replace(
              /className=/g,
              "class="
            ),
          }}
        />
      ) : clinicDetails?.prescription_HeaderYN === "N" ? (
        <div
          style={{ height: `${clinicDetails.prescription_Header_Space}px` }}
        />
      ) : null}
    </>
  );
}
